import React from 'react';


const SubsModal = ({title,icon}) => {
  return (
   <div className="fixed inset-0 z-[50] bg-black/50 flex items-center justify-center ">
      <div className="bg-white rounded-2xl shadow-xl p-6 max-w-sm text-center w-[90%] mx-auto">
        <div className="flex justify-center mb-4 items-center">
        <img className='w-[30%]' src={icon}/>
      </div>
      <h2 className="text-2xl font-bold text-black">{title}</h2>
    </div>
    </div>
  );
};

export default SubsModal;